/**
 * Do an AJAX request
 * @param parameters [{'key': 'value'}]
 * @param successCallback
 * @param errorCallback
 */
function se_postRequest(postUrl, parameters, successCallback, errorCallback) {
    const xmlHttp = new XMLHttpRequest();

    // Add the parameters
    const params = new FormData();
    const parameterKeys = Object.keys(parameters);

    for (let i = 0; i < parameterKeys.length; i++) params.append(parameterKeys[i], parameters[parameterKeys[i]]);

    xmlHttp.onreadystatechange = function () {
        if (xmlHttp.readyState === XMLHttpRequest.DONE) {
            if (xmlHttp.status === 200) {
                if (typeof successCallback !== 'undefined') successCallback(xmlHttp.responseText);
            }
            else {
                if (typeof errorCallback !== 'undefined') errorCallback();
            }
        }
    };

    xmlHttp.open('POST', postUrl, true);
    xmlHttp.send(params);
}
